import PersonalHistoryItem from './PersonalHistoryItem/PersonalHistoryItem';
import HistoryTabs from '../shared/HistoryTabs/HistoryTabs';
import Spinner from '../shared/Spinner/Spinner';
import './PersonalHistoryList.scss';

const tabs = [
  { name: 'Game ID', size: 'col-1' },
  { name: 'Uteral', size: 'col-2' },
  { name: 'Start Price', size: 'col-2' },
  { name: 'End Price', size: 'col-2' },
  { name: 'Your Bid', size: 'col-1' },
  { name: 'Result', size: 'col-1' },
  { name: 'Profit', size: 'col-2' }
];

const PersonalHistoryList = ({ games }) => {
  return (
    <div className='personal-history-list mx-auto col-11 p-4'>
      <div className='personal-history-container'>
        <HistoryTabs tabs={tabs} />

        <div className='personal-history-games px-3'>
          {games ? (
            games.map((game) => <PersonalHistoryItem key={game.id} gameInfo={game} />)
          ) : (
            <Spinner className='mt-5' />
          )}
        </div>
      </div>
    </div>
  );
};

export default PersonalHistoryList;
